import React from 'react';
import './OnePlatform.css';

function OnePlatform() {
  return (
    <section className="container py-5 my-md-3 my-lg-4 my-xl-5  ">
    <div className="row align-items-center justify-content-center  py-2 pb-sm-3">
      <div className="col-12 col-xl-4 mb-4 mb-xl-0 col-md-4 col-lg-4 col-sm-10 ">
          <div className="card shadow h-100 bg-secondary-v3 text-center">
            <div className="card-body">
            <ul className="list-unstyled">
              <li className="d-flex align-items-center text-start mb-5 h3 text-primary ">
                <i className="bx bx-check fs-icon-one-platform text-primary "></i>
                One Platform 
              </li>
              <li className="d-flex align-items-center text-start mb-5 h3 text-primary ">
                <i className="bx bx-check fs-icon-one-platform text-primary "></i>
                Every Answer
              </li>
              <li className="d-flex align-items-center text-start h3 text-primary ">
                <i className="bx bx-check fs-icon-one-platform text-primary "></i>
                Total Confidence
              </li>
            
            </ul>
              
            </div>
          </div>
      </div>
      <div className="col-12 col-xl-7  col-md-7 col-lg-7 col-sm-10 ">
        <div className="steps">
          <div className="step step-v3 pt-0 ">
            <div className="step-number">
              <div className="step-number-inner">1</div>
            </div>
            <div className="step-body d-flex align-items-center ">
              <h3 className="h5">Real-time digital workflows connecting field teams and auditors instantly</h3>
            </div>
          </div>
          <div className="step step-v3 pt-0 ">
            <div className="step-number">
              <div className="step-number-inner">2</div>
            </div>
            <div className="step-body d-flex align-items-center">
              <h3 className="h5">AI agents continuously auditing every submission against every project data point</h3>
            </div>
          </div>
          <div className="step step-v3 pt-0 ">
            <div className="step-number">
              <div className="step-number-inner">3</div>
            </div>
            <div className="step-body d-flex align-items-center ">
              <h3 className="h5">Complete document intelligence from any format, any source
              </h3>
            </div>
          </div>
          <div className="step step-v3 pt-0">
            <div className="step-number">
              <div className="step-number-inner">4</div>
            </div>
            <div className="step-body d-flex align-items-center">
              <h3 className="fs-lg">Advanced analytics and operational insights across every project</h3>
            </div>
          </div>
          <div className="step step-v3 pt-0 ">
            <div className="step-number">
              <div className="step-number-inner">5</div>
            </div>
            <div className="step-body d-flex align-items-center">
              <h3 className="fs-lg">Full traceability and transparency into every decision and action
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
}

export default OnePlatform;

